import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { RequestWorkspaceChildEntityDelete } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_delete';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__collections } from '../../collection/STATE__collections';

export const remote_workspace_child_entity_delete = createAsyncThunkSafe<void, RequestWorkspaceChildEntityDelete>(
  ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_DELETE,
  async (request, thunkApi): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_DELETE, request);
  },
);

export function init_remote_workspace_child_entity_delete(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(remote_workspace_child_entity_delete.pending, (state, action) => {})
    .addCase(remote_workspace_child_entity_delete.rejected, (state, action) => {})
    .addCase(remote_workspace_child_entity_delete.fulfilled, (state, action: PayloadAction) => {});
}
